// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Spinner_overlay__1KQ2P","spinner":"Spinner_spinner__2kvFZ","sk-rotateplane":"Spinner_sk-rotateplane__3Gb8u"};